import { Router } from '@angular/router';
import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { log } from 'console';
import { IUserInfo } from '../../../pages/administaration/ProfileInfo/Models/UserProfileModel';
import { UserService } from '../../../pages/administaration/ProfileInfo/Services/UserProfileService';
import { privateDecrypt } from 'crypto';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  admin : IUserInfo = {} as IUserInfo
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out', data: 400 }];

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserService,
    private breakpointService: NbMediaBreakpointsService,
    private route: Router,
    private eRef: ElementRef
  ) {}

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.menuService
      .onItemClick()
      .pipe(
        // Remove the tag filter, just map the item
        map(({ item }) => item)
      )
      .subscribe((item) => {
        if (item && (item.data === 400 || item.title === 'Log out')) {
          sessionStorage.removeItem('serviceAdmintoken');
          this.route.navigate(['/login']);
        }
        else if (item && (item.data === 400 || item.title === 'Profile')) {
          this.route.navigate(['/admin/user-profile']);
        }
      });
    this.userService.currentImage.subscribe((image => {
      if(image && image !== null && image !== undefined && image !== '') {
        this.admin.profilePictureFilePath = image;
      }
    }));
    this.userService.getUser().subscribe({
      next: (res) => {
        if(res && res !== null && res !== undefined) {
        this.admin = res;
        }
    }
  }
); 



    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl));

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

  }
  toggleArrow() {
    const arrow = document.querySelector('.arrow__dropDown');
    arrow.classList.toggle('opened');
  }

  // لما المستخدم يضغط في أي حتة في الصفحة
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const clickedInside = this.eRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      const arrow = document.querySelector('.arrow__dropDown');
      arrow.classList.remove('opened');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    document.body.classList.toggle('sidebar-collapsed');
    const header = document.getElementsByTagName('nb-layout-header');
    header[0].classList.toggle('sidebar-collapsed');
    console.log('header', header);

    return false;
}

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}

